import React from 'react';
import SettingsCard from './SettingsCard';
import Form from '../../../components/forms/utils/Form';
import { Switch } from '../../../components/lists/listComponents/Switch';
import { useMutation, useQuery } from '@apollo/client';
import { GET_NOTIFICATION_SETTINGS, SAVE_NOTIFICATION_SETTINGS } from '../../../utils/api/notification';
import Spinner from '../../../components/icons/Spinner';
import { NotificationType } from '../../../__generated__/graphql';

const Notifications = () => {
  const {loading, data, error} = useQuery(GET_NOTIFICATION_SETTINGS)
  const [saveSettings, {loading: saving}] = useMutation(SAVE_NOTIFICATION_SETTINGS, {
    refetchQueries: ['NotificationSettingsOne']
  })

  const enabled = data?.settings.some(({notification} : {notification: NotificationType}) => notification === NotificationType.NewCampaignApproval)
  const handleSubmit = async ({enabled}: any, _: any) => {
    await saveSettings({variables: {record: {notification: NotificationType.NewCampaignApproval, enabled}}})
  }
  return (
    <SettingsCard
    title="Notifications"
    description="Select what kind of notifications you want to receive"
  >
    {loading && <Spinner />}
    {error && <p className='p-6 text-sm text-red-600'>{error.message}</p>}
    {!loading && data && <Form
          submitButtonText="Save"
          loading={saving}
          onSubmit={handleSubmit}
          defaultValues={{
            enabled: enabled
          }}
      >
        <div className='flex p-6 justify-between'>
          <div>
            <div className='text-md leading-6 font-medium text-gray-900'>Campaign approval</div>
            <div className='mt-2 text-sm text-gray-700'>Get an email every time a campaign needs your approval</div>
          </div>

          <Switch name='enabled'/>
        </div>
        
      </Form> 
    }
    </SettingsCard>
  );
};

export default Notifications;

